import { Input } from "antd";
import { ThemeTemplateItem } from "states/theme-template/theme-template.models";

export interface IThemeSettingTextLinkProps {
  model: any;
  template: ThemeTemplateItem;
  onChange: (changedModel: any) => void;
}

export function ThemeSettingTextLink(props: IThemeSettingTextLinkProps) {
  const { model, template, onChange } = props;
  return (
    <div className="mt-2 mb-4">
      <div className="pb-2">
        <b>{template.name}</b>
      </div>
      <div className="pb-2">
        <Input
          value={model?.text ?? ""}
          placeholder="Text"
          onChange={(e) => {
            onChange({ ...model, text: e.target.value });
          }}
        />
      </div>
      <div>
        <Input
          value={model?.link ?? ""}
          placeholder="Link"
          onChange={(e) => {
            onChange({ ...model, link: e.target.value });
          }}
        />
      </div>
    </div>
  );
}
